import React from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Paper,
  Box,
} from "@mui/material";

const FilterComponent = ({
  filters,
  filterConfig,
  onFilterChange,
  onClearFilters,
}) => {
  const handleFilterChange = (fieldName, value) => {
    onFilterChange(fieldName, value);
  };

  const renderFilterField = (field) => {
    const value = filters[field.name] || "";

    switch (field.type) {
      case "text":
        return (
          <TextField
            key={field.name}
            label={field.label}
            placeholder={field.placeholder}
            value={value}
            onChange={(e) => handleFilterChange(field.name, e.target.value)}
            variant="outlined"
            size="small"
            fullWidth
          />
        );

      case "select":
        return (
          <FormControl
            key={field.name}
            variant="outlined"
            size="small"
            fullWidth
          >
            <InputLabel>{field.label}</InputLabel>
            <Select
              value={value}
              onChange={(e) => handleFilterChange(field.name, e.target.value)}
              label={field.label}
            >
              <MenuItem value="">
                <em>All</em>
              </MenuItem>
              {field.options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );

      default:
        return null;
    }
  };

  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h6" component="h3">
          Filter Schools
        </Typography>
        <Typography
          variant="body2"
          color="primary"
          sx={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={onClearFilters}
        >
          Clear All Filters
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {filterConfig.map((field) => (
          <Grid
            item
            key={field.name}
            xs={12}
            sm={field.gridSize?.sm || 6}
            md={field.gridSize?.md || 4}
            lg={field.gridSize?.lg || 3}
          >
            {renderFilterField(field)}
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default FilterComponent;
